import * as z from "zod";

export const formSchema = z.object({
	crewMemberId: z.coerce.number().min(1, { message: "Position is required" }),
});

export type FormType = z.infer<typeof formSchema>;
